import { Reveal, Eyebrow } from "./Reveal";
import { VALUES, IMAGES } from "../data/content";

export const Values = () => (
  <section id="values" data-testid="values-section" className="py-24 lg:py-32 bg-[#0B2A5B] relative overflow-hidden">
    <div className="absolute -top-40 -right-40 w-[500px] h-[500px] rounded-full bg-[#1E5FE0]/25 blur-[120px]" />
    <div className="absolute -bottom-40 -left-40 w-[400px] h-[400px] rounded-full bg-[#1E5FE0]/15 blur-[100px]" />
    <div className="max-w-7xl mx-auto px-5 sm:px-8 relative">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
        <Reveal className="lg:col-span-6">
          <Eyebrow>
            <span className="text-[#7FA8FF]">Our Values</span>
          </Eyebrow>
          <h2 className="f-display text-2xl sm:text-3xl lg:text-4xl text-white tracking-tight mt-4 max-w-2xl leading-[1.2]">
            <span className="italic">&ldquo;The gull sees farthest who flies highest.&rdquo;</span>
          </h2>
          <p className="mt-4 f-label text-xs uppercase tracking-[0.2em] text-[#7FA8FF]">
            Jonathan Livingston Seagull &mdash; Richard Bach
          </p>
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-6">
          <div className="relative rounded-[2rem] overflow-hidden aspect-[16/9] sm:aspect-[21/9]">
            <img
              src={IMAGES.eagle}
              alt="Vision and command — an eagle in flight"
              data-testid="values-image"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0B2A5B]/80 to-transparent" />
            <p className="absolute bottom-5 left-6 f-label text-xs uppercase tracking-[0.2em] text-white/90">
              What we choose, when it counts
            </p>
          </div>
        </Reveal>
      </div>

      <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 rounded-2xl overflow-hidden border border-white/10">
        {VALUES.map((v, i) => (
          <Reveal key={v.title} delay={i * 0.06} className="bg-[#0B2A5B] p-8 lg:p-10 group hover:bg-[#0E3470] transition-colors duration-500">
            <h3 className="f-display text-xl lg:text-2xl text-white leading-snug group-hover:text-[#AECBFF] transition-colors duration-500">
              {v.title}
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-white/60">{v.text}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
